export default "__VITE_ASSET__B95MNuNG__"